import { Link } from 'react-router-dom';

import HeaderSecondary from '../Header/headerSecondary';
import useTranslation from 'customHooks/translate';

const NotFoundPage = () => {
  const translation = useTranslation();

  return (
    <section className="box-border grid h-screen grid-cols-1 gap-[60px] overflow-hidden px-[24px] py-[24px]  md:pr-[24px] lg:grid-cols-2 xl:grid-cols-3 xl:gap-[120px] xl:pl-[156px]">
      <div className="col-span-1 flex flex-col gap-[96px]">
        <HeaderSecondary />
        <div className="flex flex-col gap-[24px]">
          <h1 className="text-center text-2xl font-bold text-charleston-green md:text-4xl">
            404 NOT FOUND
          </h1>
          <Link to="/">
            <div>
              <button className="flex h-12 w-full items-center justify-center gap-x-3 rounded-md bg-ultramarine-blue font-bold text-white transition-all hover:brightness-95">
                <div className="h-5 w-5">
                  <img src="assets/arrow-square-left.svg" alt="" />
                </div>
                {translation.InvoiceLine.BackHome}
              </button>
            </div>
          </Link>
        </div>
      </div>
      <div className="cols-span-1 hidden h-full overflow-hidden rounded-[24px] bg-indigo-500 lg:block xl:col-span-2">
        <img
          src="assets/not-found.svg"
          alt="login-cover"
          className="h-auto w-full object-cover"
        />
      </div>
    </section>
  );
};

export default NotFoundPage;
